"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var DrillAttributeSelectorItem_1 = require("./DrillAttributeSelectorItem");
var DrillAttributeSelectorList = function (props) {
    return (react_1.default.createElement("div", { className: "gd-drill-attribute-selector-list" }, props.supportedItems.map(function (item) { return (react_1.default.createElement(DrillAttributeSelectorItem_1.DrillAttributeSelectorItem, { key: item.attribute.attributeHeader.localIdentifier, item: item, onClick: props.onSelect, onCloseDropdown: props.onCloseDropdown })); })));
};
exports.default = DrillAttributeSelectorList;
//# sourceMappingURL=DrillAttributeSelectorList.js.map